import { render, staticRenderFns } from "./IntervalsPanel.vue?vue&type=template&id=5c2d2ae4&"
import script from "./IntervalsPanel.vue?vue&type=script&lang=js&"
export * from "./IntervalsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports